import React from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import TopLabelCustomSelectBox from "../../components/TopLabelReactSelect/TopLabelReactSelect";
import { YearsExperience } from "../../utils/constants";
import Input from "../Input/Input";
import styles from "./EducationAddMore.module.css";

const EducationalQualification = ({
  register,
  control,
  errors,
  disabled,
  subjectOptions,
}) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "educationalQualification",
  });

  React.useEffect(() => {
    if (fields.length === 0) {
      append({
        institutionName: "",
        degree: "",
        department: "",
        duration: "",
      });
    }
  }, [fields, append]);

  return (
    <div>
      <div className={styles.heading}>
        <h2>Educational Qualification (Details)</h2>
      </div>
      {fields.map((item, idx) => (
        <div className={styles.grid4} key={item.id}>
          <Input
            label="Institution Name"
            name={`educationalQualification[${idx}].institutionName`}
            register={register}
            errors={errors}
            type="text"
            disabled={disabled}
          />
          <Input
            label="Degree"
            name={`educationalQualification[${idx}].degree`}
            register={register}
            errors={errors}
            type="text"
            disabled={disabled}
          />
          <Input
            label="Department"
            name={`educationalQualification[${idx}].department`}
            register={register}
            errors={errors}
            type="text"
            disabled={disabled}
          />
          <Input
            label="Duration"
            name={`educationalQualification[${idx}].duration`}
            register={register}
            errors={errors}
            duration
            disabled={disabled}
          />
          {idx > 0 && !disabled && (
            <button
              type="button"
              className={styles.remove}
              onClick={() => remove(idx)}
            >
              X
            </button>
          )}
        </div>
      ))}
        <div className={styles.buttonOuter}>
        <div></div>
        {!disabled && (
          <button
            type="button"
            className={styles.button}
            onClick={() =>
              append({
                institutionName: "",
                degree: "",
                department: "",
                duration: "",
              })
            }
          >
            + Add More
          </button>
        )}
      </div>
    </div>
  );
};

export default EducationalQualification;
